import { RestrictedWorkspaces } from './types';

export const restrictedWorkspacesDefaultValue = {
  byId: {},
  byViewpointId: {},
} as RestrictedWorkspaces;
